import { useEffect } from 'react';

interface KeyPressSettings {
    isCarouselFocused: boolean;
    onLeftKeyPressed: () => void;
    onRightKeyPressed: () => void;
    shouldDisableLeftNavigation?: boolean;
    shouldDisableRightNavigation?: boolean;
}

enum ArrowKeysCode {
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
}

export const useKeyPress = ({
    isCarouselFocused,
    onLeftKeyPressed,
    onRightKeyPressed,
    shouldDisableLeftNavigation = false,
    shouldDisableRightNavigation = false,
}: KeyPressSettings) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const { key } = event;

            if (!isCarouselFocused) {
                return;
            }

            if (
                key === ArrowKeysCode.ArrowLeft &&
                !shouldDisableLeftNavigation
            ) {
                onLeftKeyPressed();
            } else if (
                key === ArrowKeysCode.ArrowRight &&
                !shouldDisableRightNavigation
            ) {
                onRightKeyPressed();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        isCarouselFocused,
        onLeftKeyPressed,
        onRightKeyPressed,
        shouldDisableLeftNavigation,
        shouldDisableRightNavigation,
    ]);
};
